import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';
import { SiteService } from '../services/site.service';

@Injectable({ providedIn: 'root' })
export class ReservationFeatureGuard implements CanActivate {
  constructor(private siteService: SiteService, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
    const site = this.siteService.getCurrentSite();
    if (site) {
      return site.features?.hasReservationModule ? true : this.router.createUrlTree(['/']);
    }
    return this.siteService.site$.pipe(
      filter(s => s !== null),
      take(1),
      map(s => s!.features?.hasReservationModule ? true : this.router.createUrlTree(['/']))
    );
  }
}
